var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.679 82.7426C263.285 73.6579 248.305 73.7535 239.029 83.0294L95.0294 227.029L94.7426 227.321C85.6579 236.715 85.7535 251.695 95.0294 260.971L95.3212 261.257C104.715 270.342 119.695 270.247 128.971 260.971L232 157.941V412L232.003 412.397C232.215 425.469 242.878 436 256 436C269.255 436 280 425.255 280 412V157.941L383.029 260.971L383.321 261.257C392.715 270.342 407.695 270.247 416.971 260.971C426.343 251.598 426.343 236.402 416.971 227.029L272.971 83.0294L272.679 82.7426Z",
    fill: "#222428"
  })));
};

export { SvgArrowUp as ReactComponent };
export default __webpack_public_path__ + "static/media/images/arrowUp.svg";